<template>
	<div class="dropdown" :class="dropdownClassObj">
		<button type="button" aria-label="Open Dropdown" class="dropdown-toggle__wrap" @click="toggle">
			<slot name="toggle"></slot>
		</button>
		<xyz-transition appear>
			<div
				class="dropdown-content__wrap"
				xyz="fade small-25% duration-4"
				v-xyz="`${xyzDirection}`"
				v-if="dropdownOpen"
				@click="close"
			>
				<div class="dropdown-content">
					<slot name="content"></slot>
				</div>
			</div>
		</xyz-transition>
	</div>
</template>

<script>
export default {
	name: 'Dropdown',
	props: {
		position: {
			type: String,
		},
	},
	data() {
		return {
			dropdownOpen: false,
		}
	},
	computed: {
		dropdownClassObj() {
			const classObj = {
				'dropdown--open': this.dropdownOpen,
			}
			if (this.position) {
				classObj[`dropdown--${this.position}`] = true
			}
			return classObj
		},
		xyzDirection() {
			switch (this.position) {
				case 'top-left':
					return 'origin-bottom-left'
				case 'top-right':
					return 'origin-bottom-right'
				case 'bottom-left':
					return 'origin-top-left'
				case 'bottom-right':
					return 'origin-top-right'
			}
			return 'down'
		},
	},
	methods: {
		close() {
			this.dropdownOpen = false
		},
		open() {
			this.dropdownOpen = true
		},
		toggle() {
			this.dropdownOpen = !this.dropdownOpen
		},
		onDocumentClick(event) {
			if (!this.$el.contains(event.target)) {
				this.close()
			}
		},
	},
	mounted() {
		document.addEventListener('click', this.onDocumentClick)
		document.addEventListener('touchstart', this.onDocumentClick)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.onDocumentClick)
		document.removeEventListener('touchstart', this.onDocumentClick)
	},
}
</script>

<style lang="scss" scoped>
.dropdown {
	position: relative;
}

.dropdown-toggle__wrap {
	cursor: pointer;
	padding: 0;
}

.dropdown-content__wrap {
	--xyz-in-ease: cubic-bezier(0.32, 1.4, 0.64, 1);
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	margin: $spacing-xxs 0;
	z-index: $z-dropdown;
	background-color: white;
	border-radius: $br-m;
	box-shadow: 0 0 2px theme-color(800, 0.1), 0 6px 4px -4px theme-color(800, 0.1), 0 4px 24px theme-color(900, 0.1);

	.dropdown--bottom-right & {
		left: auto;
	}

	.dropdown--bottom-left & {
		right: auto;
	}

	.dropdown--top-right & {
		left: auto;
		top: auto;
		bottom: 100%;
	}

	.dropdown--top-left & {
		right: auto;
		top: auto;
		bottom: 100%;
	}
}

.dropdown-content {
	border-radius: $br-m;
	overflow: hidden;

	::v-deep {
		li button,
		li a {
			color: inherit;
			display: flex;
			justify-content: flex-start;
			width: 100%;
			min-height: 2.5rem;
			text-align: left;
			white-space: nowrap;
			padding: $spacing-xxs $spacing-s;
			transition: background-color 0.2s $ease-out-quad, color 0.2s $ease-out-quad;

			&:hover,
			&:focus {
				background-color: theme-color(500, 0.1);
				color: theme-color(700);
			}
		}

		.button--red {
			background-color: transparentize($red, 0.85);
			color: $red;

			&:hover,
			&:focus {
				background-color: transparentize($red, 0.15);
				color: white;
			}
		}

		li {
			&:not(:last-child) {
				border-bottom: 1px solid theme-color(700, 0.1);
			}
		}
	}
}
</style>
